module.exports = __webpack_public_path__ + "static/2-117f91ac6d2499c35bb0557258ef9985.jpg";